// FIXME: грязный хак, чтобы не ругалось на WARNING in Circular dependency detected
export const adminAnalyticsPath = ':cityId/clubanalytics';
export const adminReportPath = ':cityId/clubanalytics/:name';
export const idChatPath = ':cityId/chats/id/:id';
export const idClubChatPath = ':cityId/:clubNetId/:clubId/chats/id/:id';
export const mailingPath = ':cityId/chats/mailing/:id';
export const mailingClubPath = ':cityId/:clubNetId/:clubId/chats/mailing/:id';
